import ReactDatePicker from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";

import "./style.css";

interface Props {
  isClearable?: boolean;
  onChange: (date: Date) => any;
  selectedDate: Date | undefined;
  showPopperArrow?: boolean;
}

const DatePicker = ({
  selectedDate,
  onChange,
  isClearable = false,
  showPopperArrow = false,
  ...props
}: Props & any) => {
  return (
    <ReactDatePicker
      locale={ptBR}
      selected={selectedDate}
      onChange={onChange}
      isClearable={isClearable}
      showPopperArrow={showPopperArrow}
      className="react-datapicker__input-text"
      {...props}
    />
  );
};

export default DatePicker;
